import { setCategoriesFilter, setRoomsFilter, setStatusFilter } from './actions';
import { selectDefaultFilters } from '../../selectors/offersHistory';
import { TThunkAction } from '../../types/redux';
import { FILTER_ALL_VALUE } from '../../types/offerHistory';

export const setDefaultRooms = (): TThunkAction => (dispatch, getState) => {
  const { roomCounts } = selectDefaultFilters(getState());

  dispatch(setRoomsFilter(roomCounts));
};

export const setDefaultStatus = (): TThunkAction => (dispatch, getState) => {
  const { statusCounts } = selectDefaultFilters(getState());

  dispatch(setStatusFilter(statusCounts));
};

export const setDefaultCategory = (): TThunkAction => dispatch => {
  dispatch(setCategoriesFilter(FILTER_ALL_VALUE));
};
